export default __webpack_public_path__ + "static/media/notification-msg.71371942.mp3";